import { Box, makeStyles } from '@material-ui/core'
import React from 'react'
import CustomImage from './CustomImage'
import CustomLabel from './CustomLabel'
import NuralLogo from '../assets/images/nural-logo.png'

const useStyles = makeStyles((theme) => ({
  logo: { width: 'auto', height: '25px' },
  label: { color: theme.palette.primary.main, fontWeight: 'bold', marginRight: '5px' },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
}))

export default function PoweredByNural() {
  const classes = useStyles()
  return (
    <Box className={classes.container}>
      <CustomLabel label="Powered by" className={classes.label} />
      <CustomImage image={NuralLogo} className={classes.logo} />
    </Box>
  )
}
